import { useEffect, useState } from "react";

import { CHILEAN_COMUNAS, CHILEAN_REGIONS } from "~/constants/places";
import { getComunasByRegionId } from "~/data/chileLocations";

export interface LocationState {
  selectedRegion: string;
  setSelectedRegion: (region: string) => void;
  selectedComuna: string;
  setSelectedComuna: (comuna: string) => void;
  availableComunas: { id: string; name: string }[];
}

/**
 * Hook for managing region and comuna state
 */
export const useLocationState = (
  initialRegion: string = "",
  initialComuna: string = ""
): LocationState => {
  const [selectedRegion, setSelectedRegion] = useState<string>(initialRegion);
  const [selectedComuna, setSelectedComuna] = useState<string>(initialComuna);
  const [availableComunas, setAvailableComunas] = useState<
    { id: string; name: string }[]
  >([]);

  // Update available comunas when region changes
  useEffect(() => {
    if (selectedRegion) {
      const comunas = getComunasByRegionId(selectedRegion).sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      setAvailableComunas(comunas);
    } else {
      setAvailableComunas([]);
    }

    // Reset comuna when region changes, unless we're initializing
    if (selectedRegion !== initialRegion) {
      setSelectedComuna("");
    }
  }, [selectedRegion, initialRegion]);

  return {
    selectedRegion,
    setSelectedRegion,
    selectedComuna,
    setSelectedComuna,
    availableComunas,
  };
};

/**
 * Helper function to get region or comuna name by ID using constants data
 */
export const getLocationNames = (
  regionId?: string,
  comunaId?: string
): { regionName?: string; comunaName?: string } => {
  let regionName, comunaName;

  if (regionId) {
    const region = CHILEAN_REGIONS.find((r) => r.value === regionId);
    regionName = region?.label;
  }

  if (comunaId) {
    const comuna = CHILEAN_COMUNAS.find((c) => c.value === comunaId);
    comunaName = comuna?.label;
    console.log("Found comuna:", comuna, "for ID:", comunaId);
  }

  console.log("getLocationNames result:", { regionName, comunaName });
  return { regionName, comunaName };
};
